import React from 'react';

function SelectInput({
  name,
  id,
  label,
  value,
  onChange,
  error = null,
  required = true,
  disabled = false,
  placeholder = null,
  children,
}) {
  return (
    <div className="mb-2">
      <div className="flex">
        <label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label}
        </label>
        {required ? <label className="text-red-500"> *</label> : null}
      </div>

      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`mt-1 py-2 px-2 block w-full rounded border-gray-300 border focus:border-primary ${
          error ? 'border-red-500' : ''
        }`}
      >
        {placeholder != null ? <option value="">{placeholder}</option> : null}
        {children}
      </select>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}

export default SelectInput;
